(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-hub"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initContactHub(root) {
      if (!root || root.dataset.contactHubInit === 'true') return;
      root.dataset.contactHubInit = 'true';

      var form = root.querySelector('.contact-form');
      if (!form) return;

      var volumeSegmented = form.querySelector('.contact-hub__volume-segmented');
      var volumeChips = volumeSegmented ? Array.from(volumeSegmented.querySelectorAll('.contact-hub__volume-chip')) : [];
      var volumeInput = form.querySelector('input[name="contact[estimated_volume]"]');

      var urlParams = new URLSearchParams(window.location.search);

      var inquiryParam = (urlParams.get('inquiry') || '').trim();
      if (inquiryParam) {
        var inquiryRadios = form.querySelectorAll('input[type="radio"][name="contact[contact_reason]"]');
        inquiryRadios.forEach(function (radio) {
          if (radio.value === inquiryParam) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }

      if (volumeChips.length && volumeInput) {
        var volumeParam = (urlParams.get('volume') || '').trim();

        function setActiveChip(chip) {
          volumeChips.forEach(function (c) {
            var isActive = c === chip;
            c.setAttribute('aria-checked', isActive ? 'true' : 'false');
            c.setAttribute('tabindex', isActive ? '0' : '-1');
          });
          volumeInput.value = chip.dataset.value || '';
          volumeInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        var initial = null;
        if (volumeParam) {
          initial = volumeChips.find(function (c) { return c.dataset.value === volumeParam; }) || null;
        }
        if (initial) setActiveChip(initial);

        volumeChips.forEach(function (chip, idx) {
          chip.addEventListener('click', function () { setActiveChip(chip); });
          chip.addEventListener('keydown', function (event) {
            var key = event.key;
            if (key !== 'ArrowLeft' && key !== 'ArrowRight' && key !== 'Home' && key !== 'End' && key !== ' ' && key !== 'Enter') return;
            event.preventDefault();
            if (key === 'Enter' || key === ' ') { setActiveChip(chip); return; }
            var target = chip;
            if (key === 'ArrowLeft') target = volumeChips[(idx - 1 + volumeChips.length) % volumeChips.length];
            if (key === 'ArrowRight') target = volumeChips[(idx + 1) % volumeChips.length];
            if (key === 'Home') target = volumeChips[0];
            if (key === 'End') target = volumeChips[volumeChips.length - 1];
            setActiveChip(target);
            target.focus();
          });
        });
      }

      var gamification = root.querySelector('.contact-hub__gamification');
      if (gamification) {
        var textNode = gamification.querySelector('.contact-hub__gamification-text');
        var fillNode = gamification.querySelector('.contact-hub__gamification-fill');
        var praises = [
          gamification.dataset.praise0 || '',
          gamification.dataset.praise1 || '',
          gamification.dataset.praise2 || '',
          gamification.dataset.praise3 || '',
          gamification.dataset.praise4 || ''
        ];
        var completeMsg = gamification.dataset.praiseComplete || '';

        var trackedFields = Array.from(form.querySelectorAll(
          'input[name="contact[name]"], input[name="contact[email]"], input[name="contact[phone]"], input[name="contact[company]"], input[name="contact[estimated_volume]"], textarea[name="contact[body]"]'
        ));
        var inquiryRadios = form.querySelectorAll('input[type="radio"][name="contact[contact_reason]"]');
        var inquiryCount = inquiryRadios.length > 0 ? 1 : 0;

        function isFilled(el) {
          if (!el) return false;
          return String(el.value || '').trim().length > 0;
        }

        function hasInquirySelection() {
          return !!form.querySelector('input[type="radio"][name="contact[contact_reason]"]:checked');
        }

        function computeProgress() {
          var total = trackedFields.length + inquiryCount;
          if (total === 0) return 0;
          var filled = trackedFields.reduce(function (acc, el) { return acc + (isFilled(el) ? 1 : 0); }, 0);
          if (inquiryCount && hasInquirySelection()) filled += 1;
          return Math.round((filled / total) * 100);
        }

        function messageFor(progress) {
          if (progress >= 100) return completeMsg || praises[4] || '';
          if (progress <= 0) return praises[0] || '';
          if (progress < 25) return praises[1] || praises[0] || '';
          if (progress < 55) return praises[2] || praises[1] || '';
          if (progress < 85) return praises[3] || praises[2] || '';
          return praises[4] || praises[3] || '';
        }

        function render() {
          var progress = computeProgress();
          var bucket = progress >= 100 ? 100 : Math.floor(progress / 25) * 25;
          gamification.dataset.progress = String(bucket);
          if (fillNode) fillNode.style.width = progress + '%';
          if (textNode) {
            var newMsg = messageFor(progress);
            if (textNode.textContent !== newMsg) textNode.textContent = newMsg;
          }
        }

        trackedFields.forEach(function (el) {
          el.addEventListener('input', render);
          el.addEventListener('change', render);
          el.addEventListener('blur', render);
        });

        inquiryRadios.forEach(function (el) {
          el.addEventListener('change', render);
        });

        render();
      }

      form.addEventListener('submit', function () {
        var btn = form.querySelector('.contact-form__submit');
        if (btn) {
          btn.setAttribute('disabled', 'disabled');
          btn.setAttribute('aria-busy', 'true');
        }
      });

      var posted = form.querySelector('.contact-form__success');
      if (posted && typeof posted.scrollIntoView === 'function') {
        try { posted.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { /* no-op */ }
      }
    }

    function boot() {
      document.querySelectorAll('.contact-hub').forEach(initContactHub);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target && event.target.querySelector ? event.target.querySelector('.contact-hub') : null;
      if (section) initContactHub(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fast-quote-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var globalBound = false;
    var chipBound = new WeakSet();

    function getHero() {
      return (
        document.querySelector('section.hero, section.hero-carousel') ||
        document.querySelector('.contact-hub__hero')
      );
    }

    function getFooterBoundary() {
      return (
        document.querySelector('[data-site-footer-boundary]') ||
        document.querySelector('[data-site-footer-bottom]') ||
        document.querySelector('footer.site-footer, footer.footer, footer')
      );
    }

    function getBarHeight(bars) {
      if (!bars.length) return 88;
      var max = 0;
      bars.forEach(function (bar) {
        var h = Math.ceil(bar.getBoundingClientRect().height);
        if (h > max) max = h;
      });
      return max || 88;
    }

    function setBarVisible(bars, visible) {
      bars.forEach(function (bar) {
        bar.classList.toggle('fast-quote-bar--visible', visible);
        bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      });
    }

    function updateBarVisibility(bars) {
      var hero = getHero();
      var footerBoundary = getFooterBoundary();
      var barHeight = getBarHeight(bars);
      var pastHero = !hero || hero.getBoundingClientRect().bottom <= 0;

      var footerInView = false;
      if (footerBoundary) {
        var fr = footerBoundary.getBoundingClientRect();
        var hideOffset = barHeight + 16;
        footerInView = fr.top < window.innerHeight - hideOffset && fr.bottom > 0;
      }

      setBarVisible(bars, pastHero && !footerInView);
    }

    function bindChips(bar) {
      if (chipBound.has(bar)) return;
      chipBound.add(bar);

      var chips = bar.querySelectorAll('.fast-quote-bar__chip');
      var cta = bar.querySelector('.fast-quote-bar__cta');
      if (!chips.length || !cta) return;

      var baseUrl;
      try {
        baseUrl = new URL(cta.href, window.location.origin);
      } catch (e) {
        return;
      }

      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          chips.forEach(function (c) {
            c.setAttribute('aria-checked', 'false');
          });
          chip.setAttribute('aria-checked', 'true');

          var value = chip.dataset.value;
          if (!value) return;
          baseUrl.searchParams.set('inquiry', value);
          cta.href = baseUrl.toString();
        });
      });
    }

    function initBars(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var bars = scope.querySelectorAll('.fast-quote-bar');
      if (!bars.length) return [];

      bars.forEach(bindChips);
      return Array.prototype.slice.call(bars);
    }

    function boot(root) {
      var bars = initBars(root);
      if (!bars.length) return;

      updateBarVisibility(bars);

      if (!globalBound) {
        globalBound = true;
        window.addEventListener(
          'scroll',
          function () {
            updateBarVisibility(document.querySelectorAll('.fast-quote-bar'));
          },
          { passive: true }
        );
        window.addEventListener('resize', function () {
          updateBarVisibility(document.querySelectorAll('.fast-quote-bar'));
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        boot(document);
      });
    } else {
      boot(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target) boot(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-footer-back-top]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-mobile-nav-root]').forEach(function (root) {
      var drawer = root.querySelector('[data-drawer-root]');
      var openBtn = root.querySelector('[data-drawer-open]');
      if (!drawer || !openBtn) return;

      var backdrop = drawer.querySelector('[data-drawer-backdrop]');
      var closeBtn = drawer.querySelector('[data-drawer-close]');
      var focusableSel = 'a[href], button:not([disabled]), summary';

      function getFocusables() {
        return Array.prototype.slice.call(drawer.querySelectorAll(focusableSel));
      }

      function openDrawer() {
        drawer.removeAttribute('hidden');
        drawer.setAttribute('aria-hidden', 'false');
        openBtn.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        window.setTimeout(function () {
          var first = closeBtn || getFocusables()[0];
          if (first) first.focus();
        }, 50);
      }

      function closeDrawer() {
        drawer.setAttribute('hidden', '');
        drawer.setAttribute('aria-hidden', 'true');
        openBtn.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        openBtn.focus();
      }

      function onKeydown(e) {
        if (e.key !== 'Escape' || drawer.hasAttribute('hidden')) return;
        closeDrawer();
      }

      openBtn.addEventListener('click', function () {
        if (drawer.hasAttribute('hidden')) openDrawer();
      });

      if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
      if (backdrop) backdrop.addEventListener('click', closeDrawer);

      drawer.querySelectorAll('[data-drawer-link]').forEach(function (link) {
        link.addEventListener('click', closeDrawer);
      });

      document.addEventListener('keydown', onKeydown);

      drawer.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab' || drawer.hasAttribute('hidden')) return;
        var items = getFocusables();
        if (items.length === 0) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });
    });
  })();

  (function () {
    var body = document.body;
    var headerEl = document.querySelector('.site-header-anchor .header.awf-header');

    function heroOverlapTarget() {
      return (
        document.querySelector('.hero-carousel') ||
        document.querySelector('.hero[data-hero-text-tone]') ||
        document.querySelector('.contact-hub__hero[data-hero-text-tone]')
      );
    }

    function heroUsesLightHeader() {
      var carousel = document.querySelector('.hero-carousel');
      if (carousel) {
        var activeSlide = carousel.querySelector('.hero-carousel__slide.is-active');
        return activeSlide && activeSlide.getAttribute('data-text-tone') === 'light';
      }

      var hero =
        document.querySelector('.hero[data-hero-text-tone="light"]') ||
        document.querySelector('.contact-hub__hero[data-hero-text-tone="light"]');
      return Boolean(hero);
    }

    function headerBlockHeight() {
      var bar = document.querySelector('.site-header-anchor .header');
      return bar ? bar.getBoundingClientRect().height : 72;
    }

    var scheduled = false;
    function syncHeaderState() {
      var h = headerBlockHeight();
      document.documentElement.style.setProperty('--site-header-offset', Math.round(h) + 'px');

      var y = window.scrollY || document.documentElement.scrollTop;
      var scrolled = y > 2;
      body.classList.toggle('header--scrolled', scrolled);
      if (headerEl) headerEl.classList.toggle('header--active', scrolled);

      var hero = heroOverlapTarget();
      if (hero && heroUsesLightHeader()) {
        var r = hero.getBoundingClientRect();
        body.classList.toggle('header--hero-light', r.top < h && r.bottom > h);
      } else {
        body.classList.remove('header--hero-light');
      }
    }

    function onScrollOrResize() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        syncHeaderState();
      });
    }

    document.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);
    document.addEventListener('hero-carousel:change', onScrollOrResize);

    var hero = heroOverlapTarget();
    if (hero && typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(onScrollOrResize).observe(hero);
    }
    syncHeaderState();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    class HeroCarousel {
      constructor(el) {
        this.el      = el;
        this.slides  = Array.from(el.querySelectorAll('.hero-carousel__slide'));
        this.dots    = Array.from(el.querySelectorAll('[data-carousel-dot]'));
        this.prevBtn = el.querySelector('[data-carousel-prev]');
        this.nextBtn = el.querySelector('[data-carousel-next]');

        this.count   = this.slides.length;
        this.current = 0;
        this.timer   = null;
        this.autoplay = el.dataset.autoplay === 'true';
        this.speed    = parseInt(el.dataset.speed, 10) || 5000;

        if (this.count <= 1) return;

        this._bindEvents();
        this._startTimer();
      }

      goTo(index) {
        var prev = this.current;
        this.current = ((index % this.count) + this.count) % this.count;
        if (prev === this.current) return;

        this._setSlide(this.slides[prev], false);
        if (this.dots[prev]) this._setDot(this.dots[prev], false);

        this._setSlide(this.slides[this.current], true);
        if (this.dots[this.current]) this._setDot(this.dots[this.current], true);
        this.el.dispatchEvent(new CustomEvent('hero-carousel:change', { bubbles: true }));
      }

      _setSlide(slide, active) {
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        var video = slide.querySelector('video');
        if (!video) return;
        if (active) {
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      }

      _setDot(dot, active) {
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', String(active));
      }

      _startTimer() {
        if (!this.autoplay) return;
        var self = this;
        this.timer = setInterval(function () { self.goTo(self.current + 1); }, self.speed);
      }

      _stopTimer() {
        clearInterval(this.timer);
        this.timer = null;
      }

      _resetTimer() {
        this._stopTimer();
        this._startTimer();
      }

      _bindEvents() {
        var self = this;

        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', function () { self.goTo(self.current - 1); self._resetTimer(); });
        }
        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', function () { self.goTo(self.current + 1); self._resetTimer(); });
        }

        this.dots.forEach(function (dot, i) {
          dot.addEventListener('click', function () { self.goTo(i); self._resetTimer(); });
        });

        this.el.addEventListener('mouseenter', function () { self._stopTimer(); });
        this.el.addEventListener('mouseleave', function () { self._startTimer(); });
        this.el.addEventListener('focusin',    function () { self._stopTimer(); });
        this.el.addEventListener('focusout',   function () { self._startTimer(); });

        this.el.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft')  { self.goTo(self.current - 1); self._resetTimer(); }
          if (e.key === 'ArrowRight') { self.goTo(self.current + 1); self._resetTimer(); }
        });
      }
    }

    /* Inicializa todos os carrosséis da página */
    document.querySelectorAll('[data-hero-carousel]').forEach(function (el) {
      el._carouselInstance = new HeroCarousel(el);
    });

    /* Integração com o editor do Shopify */
    document.addEventListener('shopify:block:select', function (e) {
      var carousel = e.target.closest('[data-hero-carousel]');
      if (!carousel || !carousel._carouselInstance) return;
      var idx = parseInt(e.target.dataset.slideIndex, 10);
      if (!isNaN(idx)) {
        carousel._carouselInstance.goTo(idx);
        carousel._carouselInstance._stopTimer();
      }
    });

    document.addEventListener('shopify:block:deselect', function (e) {
      var carousel = e.target.closest('[data-hero-carousel]');
      if (!carousel || !carousel._carouselInstance) return;
      carousel._carouselInstance._resetTimer();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid-b2b"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.section-product-grid-b2b');
    sections.forEach(function (section) {
      var tabs = section.querySelectorAll('.product-showcase__tab');
      var grid = section.querySelector('.product-showcase__grid');
      var emptyState = section.querySelector('[data-empty-filter]');
      if (!grid) return;

      var cards = Array.prototype.slice.call(grid.querySelectorAll('.product-showcase__card'));
      var showMoreWrap = section.querySelector('[data-show-more-wrap]');
      var showMoreButton = section.querySelector('[data-show-more]');
      var initialLimit = parseInt(grid.getAttribute('data-initial-limit'), 10) || cards.length;
      var expanded = false;

      function applyFilter(filter) {
        var visibleCount = 0;
        var hiddenByLimit = 0;
        cards.forEach(function (card) {
          var raw = (card.getAttribute('data-tags') || '').toLowerCase();
          var tags = raw ? raw.split(',') : [];
          var match = filter === 'all' || tags.indexOf(filter) !== -1;
          if (match) {
            card.classList.remove('is-hidden');
            visibleCount++;
            if (!expanded && visibleCount > initialLimit) {
              card.classList.add('is-load-hidden');
              hiddenByLimit++;
            } else {
              card.classList.remove('is-load-hidden');
            }
          } else {
            card.classList.add('is-hidden');
            card.classList.remove('is-load-hidden');
          }
        });
        if (emptyState) {
          if (visibleCount === 0) {
            emptyState.removeAttribute('hidden');
          } else {
            emptyState.setAttribute('hidden', '');
          }
        }
        if (showMoreWrap) {
          if (!expanded && hiddenByLimit > 0) {
            showMoreWrap.removeAttribute('hidden');
          } else {
            showMoreWrap.setAttribute('hidden', '');
          }
        }
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) { t.setAttribute('aria-selected', 'false'); });
          tab.setAttribute('aria-selected', 'true');
          expanded = false;
          applyFilter((tab.getAttribute('data-filter') || 'all').toLowerCase());
        });
      });

      if (showMoreButton) {
        showMoreButton.addEventListener('click', function () {
          var activeTab = section.querySelector('.product-showcase__tab[aria-selected="true"]');
          var filter = activeTab ? (activeTab.getAttribute('data-filter') || 'all').toLowerCase() : 'all';
          expanded = true;
          applyFilter(filter);
        });
      }

      var activeTab = section.querySelector('.product-showcase__tab[aria-selected="true"]');
      applyFilter(activeTab ? (activeTab.getAttribute('data-filter') || 'all').toLowerCase() : 'all');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-showcase"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.section-product-showcase');
    
    sections.forEach(section => {
      const tabs = section.querySelectorAll('.product-showcase__tab');
      const grid = section.querySelector('.product-showcase__grid');
      
      if (!tabs.length || !grid) return;
      
      const cards = Array.from(grid.querySelectorAll('.product-showcase__card'));
      
      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          // Update aria-selected
          tabs.forEach(t => t.setAttribute('aria-selected', 'false'));
          tab.setAttribute('aria-selected', 'true');
          
          const filter = tab.dataset.filter;
          
          // Filter and sort cards
          let visibleCards = [];
          
          cards.forEach(card => {
            const events = card.dataset.events.split(',');
            if (events.includes(filter)) {
              card.classList.remove('is-hidden');
              visibleCards.push(card);
            } else {
              card.classList.add('is-hidden');
            }
          });
          
          // Sort by weight
          visibleCards.sort((a, b) => {
            const weightA = parseInt(a.dataset.weight || 0);
            const weightB = parseInt(b.dataset.weight || 0);
            return weightA - weightB;
          });
          
          // Re-append to DOM to update order visually and semantically
          visibleCards.forEach(card => grid.appendChild(card));
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
